import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

import { AuthService } from '../shared-components/ng-login/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class LogoutBeforeSelector implements CanActivate {

  constructor(private authService: AuthService) {
  }

  canActivate(): boolean {
    this.authService.logout();

    return true;
  }

}
